export const productShortName = 'Mechanical Engineering — Professional Edition™';
export const productBrand = 'Mechanical Engineering';
export const productEdition = 'Professional Edition™';
export const productImage = 'https://cdn.magicpatterns.com/uploads/ih1fxEKJgicHBUpdLUPQaV/MOCKUP_5.35.44_p._m..png';

export const checkoutUrl = 'https://mechanical-engineering-professional-edition.impultienda.ar/checkout';

export const price = 'USD 27.00';
export const priceBefore = 'USD 80.00';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70.00';

export const closingLines = [
  'No more confusion about mechanical design calculations',
  'No more uncertain technical explanations to colleagues',
  'No more struggling with material selection decisions',
  'No more gaps in understanding equipment reliability',
  "No more limited career advancement because technical knowledge isn't documented",
];
